import {
  faBookmark,
  faSquareSliders,
} from "@fortawesome/duotone-light-svg-icons"
import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useBonusRewardModalStore } from "./BonusRewardModal"
import { useDeductCoinsModalStore } from "./DeductCoinsModal"
import useAddEditRewardModalStore from "./hooks/useAddEditRewardModalStore"
import { useRewardTemplatesModal } from "./RewardTemplates"
import AnimatedButtonGroup from "../../components/buttonGroup/AnimatedButtonGroup"

export const AddRewardButton = () => {
  const { onOpen: openAddRewardModal } = useAddEditRewardModalStore()
  const { onOpen: openRewardTemplatesModal } = useRewardTemplatesModal()
  const { onOpen: openBonusRewardModal } = useBonusRewardModalStore()
  const { onOpen: openDeductCoinsModal } = useDeductCoinsModalStore()
  const { t } = useTranslation()

  return (
    <>
      <AnimatedButtonGroup>
        <Button
          text={t("REWARD_CUSTOM_REWARD")}
          onClick={() => openAddRewardModal()}
          icon={faSquareSliders}
        />
        <Button
          text={t("REWARD_START_FROM_TEMPLATE")}
          onClick={openRewardTemplatesModal}
          icon={faBookmark}
        />
        <Button
          text={
            <div className="flex flex-row gap-1 items-center w-[200px]">
              <img
                src={"/images/icons/coin-icon.png"}
                alt="bonus reward"
                className="w-4 h-4"
              />
              <Typography
                variant="body"
                color={JoonUIColor.text.inverted}
                className="whitespace-nowrap"
              >
                {t("REWARD_SEND_BONUS_COIN")}
              </Typography>
            </div>
          }
          onClick={openBonusRewardModal}
        />
        <Button
          text={
            <div className="flex flex-row gap-1 items-center">
              <img
                src={"/images/icons/minus-coin.png"}
                alt="bonus reward"
                className="w-4 h-4"
              />
              <Typography
                variant="body"
                color={JoonUIColor.text.inverted}
                className="whitespace-nowrap"
              >
                {t("REWARD_DEDUCT_COINS")}
              </Typography>
            </div>
          }
          onClick={openDeductCoinsModal}
        />
      </AnimatedButtonGroup>
    </>
  )
}
